import { Grid, Paper, Table, TableBody, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { GhabzModel } from "../../Api/Models/GhabzModel";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import AppLoading from "../../Components/MDLoading";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { GhabzDto } from "../../Types/Api/DTO/GhabzDto";
import { PaginatedResponse } from "../../Types/Api/Response";
import { v4 as uuid } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MDDragable from "../../Components/Dragable";
import MDButton from "../../Components/MDButton";
import { SuccessToaast } from "../../utils/toast/Toast";
import { useNavigate } from "react-router-dom";
import PrintEdit from "../../Components/Icons/PrintEdit";
export default function GhabzList() {
  const ghabzModel = new GhabzModel();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [deleteParams, setDeleteParams] = useState({ name: "", id: 0 });
  const [rows, setRows] = useState<PaginatedResponse<any>>({
    content: [],
    pageSize: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    ghabzModel
      .getAllWithPaginate(pageNumber, pageSize)
      .then((r) => {
        setRows(r.data.data);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      ghabzModel.baseApi.handleCancelRequest();
    };
  }, [pageNumber, pageSize, counter]);
  ///pagination///
  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage + 1);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageSize(+event.target.value);
    setPageNumber(1);
  };

  //\//\\pagination//\\//\\
  function defaultLabelDisplayedRows({ from, to, count }: any) {
    return `${from}–${to} ${t("از")} ${count !== -1 ? count : `${t("more than")} ${to}`}`;
  }
  const handleDelete = async () => {
    setLoading(true);
    await ghabzModel
      .delete(deleteParams.id)
      .then((r) => {
        SuccessToaast("با موفقیت حذف شد");
      })
      .catch((r) => console.log(r));
    await setOpen(false);
    await setCounter((c) => c + 1);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"لیست قبوض"} />
      <MDBox py={3} bgColor="white" p={2} mb={2} flex={1} borderRadius={2}>
        <Grid container flexDirection={"column"}>
          <Grid item>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                      نام قبض
                    </MDTableCell>
                    <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                      نام بانک
                    </MDTableCell>

                    <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                      پیام عوارض
                    </MDTableCell>

                    <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                      فرمول
                    </MDTableCell>
                    <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                      عملیات
                    </MDTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.content.length < 1 && (
                    <MDTableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <MDTableCell colSpan={6} align="right">
                        هیچ ایتمی برای نمایش وجود ندارد.
                      </MDTableCell>
                    </MDTableRow>
                  )}
                  {rows.content.map((r) => {
                    return (
                      <MDTableRow hover role="checkbox" tabIndex={-1} key={uuid()}>
                        <MDTableCell align={"center"}>{r?.avarezName}</MDTableCell>
                        <MDTableCell align={"center"}>{r?.bankAccountBankName}</MDTableCell>
                        <MDTableCell align={"center"}>
                          <Tooltip title={r?.message}>
                            <div>
                              {r?.message.length > 40 && r?.message.slice(0, 40) + "..."}
                              {r?.message.length <= 40 && r?.message}
                            </div>
                          </Tooltip>
                        </MDTableCell>
                        <MDTableCell align={"center"}>{r?.formula}</MDTableCell>
                        <MDTableCell key={uuid()} align={"center"}>
                          <>
                            <DeleteIcon
                              color="error"
                              fontSize="medium"
                              sx={{ cursor: "pointer", mx: 2 }}
                              onClick={() => {
                                setDeleteParams({ name: r.avarezName, id: r.id });
                                setOpen(true);
                              }}
                            />
                            <EditIcon
                              onClick={() => navigate(`/editghabz/edit?id=${r?.id}`)}
                              color="info"
                              fontSize="medium"
                              sx  ={{ cursor: "pointer", mx: 2 }}
                            />
                            <PrintEdit
                              onClick={() => window.open("/webroutes/Ghabz/" + r.id)}
                              color="info"
                              fontSize="medium"
                              sx={{ cursor: "pointer", mx: 2 }}
                            />
                          </>
                        </MDTableCell>
                      </MDTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {rows?.content.length > 0 && (
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.totalPages}
                rowsPerPage={pageSize}
                page={pageNumber - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={defaultLabelDisplayedRows}
                labelRowsPerPage={<>تعداد در هر ردیف </>}
              />
            )}
          </Grid>
        </Grid>
      </MDBox>
      <MDDragable
        open={open}
        setOpen={setOpen}
        title="حذف پارامتر"
        desciption={`ایا از حذف ${deleteParams?.name} اطمینان دارید ؟`}
        buttons={
          <Grid container justifyContent={"flex-start"}>
            <MDButton onClick={handleDelete}>تایید</MDButton>
            <MDButton autoFocus onClick={() => setOpen(false)}>
              بستن
            </MDButton>
          </Grid>
        }
      />

      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
